import { useEffect, useState, useRef } from 'react';

function useMinuteRerender(isTimeBasedComponentsExists) {
  const [, setTick] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!isTimeBasedComponentsExists) {
      return () => {}; // always return a cleanup function (does nothing)
    }

    const now = new Date();
    const msToNextMinute = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();

    const timeoutId = setTimeout(() => {
      setTick((t) => t + 1);

      intervalRef.current = setInterval(() => {
        setTick((t) => t + 1);
      }, 60000);
    }, msToNextMinute);

    return () => {
      clearTimeout(timeoutId);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isTimeBasedComponentsExists]);
}

export default useMinuteRerender;
